import React from 'react';

import clsx from 'clsx';

import classes from './BobPage.module.css';

const BobPage = ({
    children,
    className,
    ...props
}) => {

    return (
        <div className={clsx(classes.BobPage, className)}>
            {children}
        </div>
    );
};

export default BobPage;
